<div *ngrxLet="treatmentStep$ as treatmentStep" class="flex flex-col">
  <ng-container *ngrxLet="selectedTreatment$ as selectedTreatment">
    <div class="flex items-center justify-between">
      <div class="flex w-full flex-col gap-6" class="title-group">
        <h2>Treatment</h2>
        <ng-container *ngrxLet="allPatientPlans$ as patientPlans">
          <ng-container *ngIf="patientPlans.length">
            <ng-container *ngIf="!selectPlanControl.value; else planSelected">
              <mat-hint>
                Creating New Plan or
                <a
                  href="javascript:void(0);"
                  class="action-link"
                  [matMenuTriggerFor]="planMenu"
                >
                  Select from existing plans
                </a>
              </mat-hint>
            </ng-container>
            <ng-template #planSelected>
              <mat-hint *ngIf="selectedTreatment | map: canChangePlan">
                <span *ngIf="isMostRecentPlan$ | async; else addToOtherPlan">
                  Adding as step to most recent plan:
                </span>
                <ng-template #addToOtherPlan> Adding as step to: </ng-template>
                <a
                  href="javascript:void(0);"
                  class="selected-plan"
                  [matMenuTriggerFor]="planMenu"
                >
                  <mat-icon>edit</mat-icon> {{ selectPlanControl.value?.name }}
                </a>
              </mat-hint>
            </ng-template>
          </ng-container>

          <mat-menu #planMenu="matMenu">
            <button mat-menu-item (click)="setPlan()">Create New Plan</button>
            <button
              *ngFor="
                let plan of patientPlans | map: filterPlans : this;
                trackBy: trackByPlan
              "
              mat-menu-item
              (click)="setPlan(plan)"
            >
              {{ plan.name }}
            </button>
          </mat-menu>
        </ng-container>

        <div class="flex gap-4">
          <a
            *ngIf="selectedTreatment"
            href="javascript:void(0);"
            class="action-link"
            (click)="resetSelectedTreatment()"
          >
            <mat-icon>edit</mat-icon> Change Selected Treatment
          </a>
          <a
            *ngIf="selectedTreatment | map: isTreatmentPlan"
            class="action-link"
            [prBrandRouterLink]="treatmentPlanLink$ | async"
          >
            <mat-icon>visibility</mat-icon> View Plan
          </a>
        </div>
      </div>
    </div>

    <div *ngIf="treatmentStep; else selectTreatment" class="step-container">
      <div class="flex gap-2">
        <div class="mat-caption step-name" class="flex-1">
          <input
            matInput
            autocomplete="off"
            type="text"
            class="custom-input-default w-full"
            placeholder="Step Name"
            [formControl]="stepNameCtrl"
          />
        </div>
        <pr-treatment-step-category-indicator
          displayOnly
          [treatmentStepDisplay]="treatmentStep.display"
          (stepDisplayChange)="updateStepDisplay($event)"
        />
      </div>
      <pr-treatment-scope-list
        [disabled]="treatmentStep | map: isComplete"
        [treatments]="treatmentStep.treatments"
        [step]="treatmentStep"
        [plan]="treatmentPlan$ | async"
        [compact]="true"
        (treatmentsChange)="updateTreatments($event)"
        (treatmentDeleted)="deleteTreatment($event)"
        (updateChartable)="updateChartable($event)"
        (categoryChanged)="updateStepDisplayOverride(treatmentStep, $event)"
      />
      @if (treatmentStep | map: isIncomplete) {
        <pr-add-charted-treatment-button
          [inlcudeMultiTreatments]="false"
          (addChartable)="
            addChartable($event.chartable, $event.selectedSurfaces)
          "
        />
      }
    </div>

    <div *ngrxLet="appointmentDetails$ as appointmentDetails">
      <div *ngrxLet="schedulingAlerts$ as alerts">
        <div
          *ngIf="alerts.length"
          class="flex items-center justify-start gap-4"
        >
          <mat-icon color="accent">warning</mat-icon>
          <h4 *ngFor="let alert of alerts; trackBy: trackByAlert" class="alert">
            {{ alert }}
          </h4>
        </div>
      </div>

      <ng-container *ngrxLet="durationWarningMessage$ as warning">
        <div
          *ngIf="warning.length"
          class="duration-warning-message flex items-center justify-start gap-2"
        >
          <mat-icon>warning</mat-icon>
          <span>{{ warning }}</span>
        </div>
      </ng-container>
    </div>

    <ng-template #selectTreatment>
      <div class="flex flex-col">
        <div class="flex flex-col">
          <span class="mat-caption opaque">
            Select From Treatment Templates
          </span>
          <ng-container *ngrxLet="filteredTemplates$ as templates">
            <mat-form-field class="flex-1">
              <input
                matInput
                floatLabel="none"
                [placeholder]="
                  templates.length
                    ? 'Search Templates'
                    : 'No treatments available for the selected Practitioner'
                "
                [formControl]="treatmentCtrl"
                [matAutocomplete]="treatmentAutoComplete"
                [disabled]="!templates.length"
              />

              <mat-autocomplete
                #treatmentAutoComplete="matAutocomplete"
                class="treatment-template-options"
                panelWidth="auto"
                [autoActiveFirstOption]="true"
                [displayWith]="displayFn"
              >
                <ng-container
                  *ngIf="
                    treatmentTemplateSearchFilter.results$ | async as planPairs
                  "
                >
                  <mat-option
                    *ngFor="
                      let planPair of planPairs;
                      trackBy: trackByTemplatePlanPair
                    "
                    class="!h-auto !py-2"
                    [value]="planPair"
                  >
                    <div class="flex w-full items-center justify-between gap-3">
                      <span>{{ planPair.step.name }}</span>
                      @if (
                        planPair
                          | pairMap
                            : (templateDeposits$ | async) ?? undefined
                            : templateDeposit;
                        as deposit
                      ) {
                        <pr-deposit-status-chip
                          class="shrink-0"
                          tooltipDisabled
                          [absence]="deposit"
                        />
                      }
                    </div>
                  </mat-option>
                </ng-container>
              </mat-autocomplete>

              <button
                type="button"
                matIconSuffix
                mat-icon-button
                [disabled]="treatmentDisabled$ | async"
                (click)="clearTreatment()"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </ng-container>
        </div>

        <pr-treatment-plans
          #unscheduledTreatmentSteps="prTreatmentPlans"
          [patient]="patient$ | async"
          [currentPractitioner]="currentPractitioner$ | async"
          [statuses]="treatmentStatuses"
          [filterStepStatuses]="treatmentStepStatuses"
          (stepAdded)="selectStep($event)"
        >
          <span
            *ngIf="
              (unscheduledTreatmentSteps.filteredTreatmentPlans$ | async)
                ?.length
            "
            class="mat-caption opaque"
          >
            Select From Existing Treatment Plans
          </span>
        </pr-treatment-plans>
      </div>
    </ng-template>
  </ng-container>
</div>
